<script setup>
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps({
  list: {
    type: Array,
    default() {
      return [];
    },
  },
  modelValue: {
    type: [String, Number, Array],
    default() {
      return '';
    },
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const currentTab = ref('');

const currentList = computed(() => {
  return props.list.filter((item) => {
    return item.id === currentTab.value;
  })[0]?.list;
});


watch(() => props.modelValue, (value) => {
  currentTab.value = searchParent(value)?.id;
});


const searchParent = (targetId) => {
  for (const item of props.list) {
    if (item.list && Array.isArray(item.list)) {
      for (const listItem of item.list) {
        if (listItem.id === targetId) {
          return item;
        }
      }
    }
  }

  return null;
};
const changeTab = (tab) => {
  currentTab.value = tab;
};
const handleChange = async (value) => {
  const emitValue = currentList.value.filter((item)=>{
    return item.id === value;
  })[0];

  emit('change', emitValue);
};


onMounted(() => {
  currentTab.value = searchParent(props.modelValue)?.id;
});
</script>

<template>
  <UiSelect
    :label="$t('customReports.reportBy')"
    :list="currentList"
    :model-value="modelValue"
    class="ui-select-tabs"
    insert-label
    popper-class="ui-select-tabs__dropdown"
    @update:model-value="emit('update:modelValue', $event)"
    @change="handleChange"
  >
    <template v-slot:header>
      <div class="ui-select-tabs__list">
        <div
          v-for="item in list"
          :key="item.id"
          :class="[
            'ui-select-tabs__list-item',
            {'ui-select-tabs__list-item_active': item.id === currentTab}
          ]"
          class="ui-select-tabs__list-item"
          @click="changeTab(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
    </template>
  </UiSelect>
</template>

<style lang="scss">
.ui-select-tabs {
  &__dropdown {
    .el-select-dropdown__header {
      padding: 0;
    }
  }

  &__list {
    padding: 5px 10px 0;
    background-color: #f5f5f5;
  }

  &__list-item {
    display: inline-block;
    padding: 7px 10px 3px;
    font-size: 14px;
    color: #aaa;
    text-decoration: none;
    cursor: pointer;
    line-height: 100%;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 3px 3px 0 0;
    font-family: Open Sans, serif;

    &_active {
      color: #24292e;
      background-color: #fff;
      border-color: #dfe2e5;
      border-bottom-color: #fff;
    }
  }
}
</style>